import { useEffect, useState } from "react";
import axios from "axios";
//import ExcelJS from "exceljs";
//import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./PlanActualReport.css";
import { getAuthToken } from "../../utils/token";
import config from "../../config/config";

const API_BASE_URL = config.API;

//const API_URL = "http://localhost:8000/api";

const ActivityPlanShiftReport = () => {

    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(false);


    // =========================================================
    // LOAD REPORT
    // =========================================================

    const loadReport = async () => {

        try {

            setLoading(true);

            const token = getAuthToken();

            const response = await axios.get(
                `${API_BASE_URL}/productiondailyactivity/getActivityPlanShift`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            if (response.data?.success) {

                setReport(response.data.data);

            }

        } catch (error) {

            console.error(
                "Activity Plan Shift Error:",
                error
            );

        } finally {

            setLoading(false);

        }

    };


    useEffect(() => {

        loadReport();

    }, []);


    // =========================================================
    // SAFE ITEM NAME
    // =========================================================

    const getItemName = (item) => {

        return (
            item?.Item ??
            item?.item ??
            ""
        );

    };
    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    };
    // =========================================================
    // MANPOWER CALCULATION
    // =========================================================
    const getManPower = (
        items = [],
        activities = []
    ) => {

        const itemManPower = items.reduce(
            (total, item) => {

                return (
                    total +
                    (Number(item?.Man_Power) || 0)
                );

            },
            0
        );


        const activityManPower = activities.reduce(
            (total, activity) => {

                return (
                    total +
                    (Number(activity?.Man_Power) || 0)
                );

            },
            0
        );
        return (
            itemManPower +
            activityManPower
        );
    };


    // =========================================================
    // LOADING
    // =========================================================

    if (loading) {

        return (
            <div className="text-center p-4">
                Loading report...
            </div>
        );

    }


    // =========================================================
    // NO DATA
    // =========================================================

    if (!report) {

        return (
            <div className="text-center p-4">
                No report data available.
            </div>
        );

    }


    // =========================================================
    // MANPOWER
    // =========================================================

    const shiftAManPower = getManPower(
        report.shift_a?.items || [],
        report.shift_a?.activities || []
    );
    const shiftBManPower = getManPower(
        report.shift_b?.items || [],
        report.shift_b?.activities || []
    );

    const totalManPower =
        shiftAManPower +
        shiftBManPower;


    // =========================================================
    // EXCEL EXPORT
    // =========================================================



    // =========================================================
    // PDF EXPORT
    // =========================================================

    const exportPDF = () => {

        const doc = new jsPDF({

            orientation: "landscape",

            unit: "mm",

            format: "a4",

        });


        const pageWidth =
            doc.internal.pageSize.getWidth();

        // =====================================================
        // COMPANY / HEADER
        // =====================================================

        doc.setFontSize(14);

        doc.setFont(undefined, "bold");

        doc.text(
            `NEXT DAY PRODUCTION PLAN & PRESS LOADING PLAN OF ${report.header?.Company || "PRAG INDUSTRIES INDIA PVT LTD. UNIT-1"
            }`,
            pageWidth / 2,
            10,
            {
                align: "center",
            }
        );

        // =====================================================
        // TITLE / DATE
        // =====================================================

        doc.setFontSize(9);

        doc.setFont(undefined, "normal");

        doc.text(
            `Date - ${formatDate(report.header?.PlanDate) || ""}`,
            pageWidth / 2,
            16,
            {
                align: "center",
            }
        );


        // =====================================================
        // SHIFT-A ITEMS
        // =====================================================

        autoTable(doc, {

            startY: 21,

            margin: {

                left: 5,

                right: 151,

            },

            head: [[

                report.shift_a?.shift?.Shift ||
                "SHIFT-A",

            ]],

            body: [],

            theme: "grid",

        });


        autoTable(doc, {

            startY: 29,

            margin: {

                left: 5,

                right: 151,

            },

            head: [[

                "ITEM",

                "MACHINE",

                "CAVITY",

                "PRODUCTION PLAN (12 Hrs)",

                "PLAN MANPOWER",
                "REMARK",

            ]],

            body:

                (
                    report.shift_a?.items || []
                ).map(
                    (item) => [

                        getItemName(item),

                        item.Machine_No || "",

                        item.No_Of_Cavity || "",

                        item.Production_Plan_12Hrs || "",

                        item.Man_Power || "",

                        item.Remark || "",

                    ]
                ),

            theme: "grid",

            styles: {

                fontSize: 6.5,

                cellPadding: 1.2,

            },

            headStyles: {

                fontStyle: "bold",

            },

        });


        // =====================================================
        // SHIFT-B ITEMS
        // =====================================================

        autoTable(doc, {

            startY: 21,

            margin: {

                left: 151,

                right: 5,

            },

            head: [[

                report.shift_b?.shift?.Shift ||
                "SHIFT-B",

            ]],

            body: [],

            theme: "grid",

        });


        autoTable(doc, {

            startY: 29,

            margin: {

                left: 151,

                right: 5,

            },

            head: [[

                "ITEM",

                "MACHINE",

                "CAVITY",

                "PRODUCTION PLAN (12 Hrs)",

                "PLAN MANPOWER",
                "REMARK",

            ]],

            body:

                (
                    report.shift_b?.items || []
                ).map(
                    (item) => [

                        getItemName(item),

                        item.Machine_No || "",

                        item.No_Of_Cavity || "",

                        item.Production_Plan_12Hrs || "",

                        item.Man_Power || "",

                    ]
                ),

            theme: "grid",

            styles: {

                fontSize: 6.5,

                cellPadding: 1.2,

            },

        });


        // =====================================================
        // ACTIVITIES
        // =====================================================

        const activityY = 75;


        // =====================================================
        // SHIFT-A ACTIVITIES
        // =====================================================

        autoTable(doc, {

            startY: activityY,

            margin: {

                left: 5,

                right: 151,

            },

            head: [[
                "PROCESS/ACTIVITIES",

                "MACHINE",

                "CAVITY",

                "PRODUCTION PLAN (12 Hrs)",

                "PLAN MANPOWER",
                "REMARK",


            ]],

            body:

                (
                    report.shift_a?.activities || []
                ).map(
                    (item) => [

                        getItemName(item),

                        item.Machine_No || "",

                        item.No_Of_Cavity || "",

                        item.Production_Plan_8hrs || "",

                        item.Man_Power || "",

                    ]
                ),

            theme: "grid",

            styles: {

                fontSize: 6.5,

                cellPadding: 1.2,

            },

        });


        // =====================================================
        // SHIFT-B ACTIVITIES
        // =====================================================

        autoTable(doc, {

            startY: activityY,

            margin: {

                left: 151,

                right: 5,

            },

            head: [[

                "PROCESS/ACTIVITIES",

                "MACHINE",

                "CAVITY",

                "PRODUCTION PLAN (12 Hrs)",

                "PLAN MANPOWER",
                "REMARK",


            ]],

            body:

                (
                    report.shift_b?.activities || []
                ).map(
                    (item) => [

                        getItemName(item),

                        item.Machine_No || "",

                        item.No_Of_Cavity || "",

                        item.Production_Plan_8hrs || "",

                        item.Man_Power || "",

                    ]
                ),

            theme: "grid",

            styles: {

                fontSize: 6.5,

                cellPadding: 1.2,

            },

        });


        // =====================================================
        // MANPOWER SUMMARY
        // =====================================================

        doc.setFontSize(8);

        doc.setFont(
            undefined,
            "bold"
        );


        doc.text(
            `Shift A: ${shiftAManPower}`,
            155,
            180
        );


        doc.text(
            `Shift B: ${shiftBManPower}`,
            190,
            180
        );


        doc.text(
            `Total: ${totalManPower}`,
            225,
            180
        );


        // =====================================================
        // USERS
        // =====================================================

        doc.setFont(
            undefined,
            "normal"
        );


        doc.text(

            `Created By: ${report.users?.created_by || ""
            }`,

            10,

            195

        );


        doc.text(

            `Approved By: ${report.users?.approved_by || ""
            }`,

            100,

            195

        );


        // =====================================================
        // SAVE PDF
        // =====================================================

        doc.save(
            "Next Production_Plan_.pdf"
        );

    };
    // =========================================================
    // DISPLAY REPORT
    // =========================================================
    return (
        <div className="report-container">

            {/* =================================================
                REPORT
            ================================================= */}

            <div
                id="activity-plan-report"
                className="activity-plan-report"
            >
{/* =================================================
    HEADER
================================================= */}

<div className="company-name">

    {`NEXT DAY PRODUCTION PLAN & PRESS LOADING OF ${
        report.header?.Company ||
        "PRAG INDUSTRIES INDIA PVT LTD. UNIT-1"
    }`}

    <div className="report-title">

        DATE - {formatDate(report.header?.PlanDate) || ""}

    </div>

</div>
                <div className="d-flex justify-content-end gap-1 mb-1">


                    <button
                        className="btn-pdf"
                        onClick={exportPDF}
                        disabled={!report || loading}
                    >
                        {loading
                            ? "Generating..."
                            : "Export PDF"}
                    </button>


                </div>
                {/*=================================================
                    SHIFT ITEMS
                =================================================*/}
                <div className="row g-0">
                    {/*=================================================
                        SHIFT-A
                    ================================================= */}

                    <div className="col-md-6 report-section">

                        <div className="shift-title">

                            {report.shift_a?.shift?.Shift ||
                                "SHIFT-A"}

                        </div>


                        <table className="table table-bordered report-table">

                            <thead>

                                <tr>

                                    <th>ITEM</th>

                                    <th>MACHINE NO.</th>

                                    <th>NO. OF CAVITY</th>

                                    <th>
                                        PRODUCTION PLAN
                                        <br />
                                        12 Hrs
                                    </th>

                                    <th>OPERATORS</th>

                                    <th>REMARK</th>

                                </tr>

                            </thead>


                            <tbody>

                                {report.shift_a?.items?.map(
                                    (item, index) => (

                                        <tr key={index}>

                                            <td>
                                                {getItemName(item)}
                                            </td>

                                            <td>
                                                {item.Machine_No}
                                            </td>

                                            <td>
                                                {item.No_Of_Cavity}
                                            </td>

                                            <td>
                                                {item.Production_Plan_12Hrs}
                                            </td>

                                            <td>
                                                {item.Man_Power}
                                            </td>

                                            <td>
                                                {item.Remark}
                                            </td>

                                        </tr>

                                    )
                                )}

                            </tbody>

                        </table>

                    </div>


                    {/* =================================================
                        SHIFT-B
                    ================================================= */}

                    <div className="col-md-6 report-section">

                        <div className="shift-title">

                            {report.shift_b?.shift?.Shift ||
                                "SHIFT-B"}

                        </div>


                        <table className="table table-bordered report-table">

                            <thead>

                                <tr>

                                    <th>ITEM</th>

                                    <th>MACHINE</th>

                                    <th>CAVITY</th>

                                    <th>
                                        PRODUCTION PLAN
                                        <br />
                                        8 Hrs
                                    </th>

                                    <th>OPERATORS</th>
                                    <th>REMARK</th>

                                </tr>

                            </thead>


                            <tbody>

                                {report.shift_b?.items?.map(
                                    (item, index) => (

                                        <tr key={index}>

                                            <td>
                                                {getItemName(item)}
                                            </td>

                                            <td>
                                                {item.Machine_No}
                                            </td>

                                            <td>
                                                {item.No_Of_Cavity}
                                            </td>

                                            <td>
                                                {item.Production_Plan_12Hrs}
                                            </td>

                                            <td>
                                                {item.Man_Power}
                                            </td>

                                            <td>
                                                {item.Remark}
                                            </td>

                                        </tr>

                                    )
                                )}

                            </tbody>

                        </table>

                    </div>

                </div>


                {/* =================================================
                    ACTIVITIES
                ================================================= */}

                <div className="row g-0">


                    {/* =================================================
                        SHIFT-A ACTIVITIES
                    ================================================= */}

                    <div className="col-md-6 report-section">

                        <div className="shift-title">

                            {report.shift_a?.shift?.Shift ||
                                "SHIFT-A"}

                        </div>


                        <table className="table table-bordered report-table">

                            <thead>

                                <tr>

                                    <th >PROCESS/ACTIVITIES</th>

                                    <th >MACHINE</th>

                                    <th>CAVITY</th>

                                    <th>
                                        PRODUCTION PLAN
                                        <br />
                                        8 Hrs
                                    </th>

                                    <th>PLAN MAN POWER</th>
                                    <th>REMARK</th>

                                </tr>

                            </thead>


                            <tbody>

                                {report.shift_a?.activities?.map(
                                    (item, index) => (

                                        <tr key={index}>

                                            <td>
                                                {getItemName(item)}
                                            </td>

                                            <td>
                                                {item.Machine_No}
                                            </td>

                                            <td>
                                                {item.No_Of_Cavity}
                                            </td>

                                            <td>
                                                {item.Production_Plan_8hrs}
                                            </td>

                                            <td>
                                                {item.Man_Power}
                                            </td>
                                            <td>
                                                {item.Remark}
                                            </td>

                                        </tr>

                                    )
                                )}

                            </tbody>

                        </table>

                    </div>


                    {/* =================================================
                        SHIFT-B ACTIVITIES
                    ================================================= */}

                    <div className="col-md-6 report-section">

                        <div className="shift-title">

                            {report.shift_b?.shift?.Shift ||
                                "SHIFT-B"}

                        </div>


                        <table className="table table-bordered report-table">

                            <thead>

                                <tr>

                                    <th >PROCESS/ACTIVITIES</th>
                                    <th>MACHINE</th>

                                    <th>CAVITY</th>

                                    <th>
                                        PRODUCTION PLAN
                                        <br />
                                        8 Hrs
                                    </th>

                                    <th>PLAN MAN POWER</th>
                                    <th>REMARK</th>

                                </tr>

                            </thead>


                            <tbody>

                                {report.shift_b?.activities?.map(
                                    (item, index) => (

                                        <tr key={index}>

                                            <td>
                                                {getItemName(item)}
                                            </td>

                                            <td>
                                                {item.Machine_No}
                                            </td>

                                            <td>
                                                {item.No_Of_Cavity}
                                            </td>

                                            <td>
                                                {item.Production_Plan_8hrs}
                                            </td>

                                            <td>
                                                {item.Man_Power}
                                            </td>
                                            <td>
                                                {item.Remark}
                                            </td>

                                        </tr>

                                    )
                                )}

                            </tbody>

                        </table>

                    </div>

                </div>


                {/* =================================================
                    MANPOWER SUMMARY
                ================================================= */}

                <table
                    className="table table-bordered manpower-table"
                    style={{ backgroundColor: "#00eeff" }}
                >
                    <tbody>
                        <tr>
                            <td>
                                Shift-A
                            </td>

                            <td>
                                <strong>
                                    {shiftAManPower}
                                </strong>
                            </td>

                            <td>
                                Shift-B
                            </td>

                            <td>
                                <strong>
                                    {shiftBManPower}
                                </strong>
                            </td>

                            <td>
                                <strong>
                                    Total
                                </strong>
                            </td>

                            <td>
                                <strong>
                                    {totalManPower}
                                </strong>
                            </td>
                        </tr>
                    </tbody>
                </table>


                {/* =================================================
                    USERS
                ================================================= */}

                <div className="row mt-4">

                    <div className="col-6">

                        <strong>
                            Created By:
                        </strong>{" "}

                        {report.users?.created_by || ""}

                    </div>


                    <div className="col-6">

                        <strong>
                            Approved By:
                        </strong>{" "}

                        {report.users?.approved_by || ""}

                    </div>

                </div>

            </div>

        </div>

    );

};


export default ActivityPlanShiftReport;

